import { Capacitor } from '@capacitor/core';

/**
 * Links we hand to other people — society invites, tee sheets.
 *
 * On the web, window.location.origin is the right answer. Inside the Capacitor
 * shells it is NOT: capacitor.config.ts sets androidScheme/iosScheme to 'https',
 * so the app runs at https://localhost and every shared link pointed at the
 * recipient's own machine. Native builds must use the configured public site.
 */
const WEB_URL = (process.env.REACT_APP_WEB_URL || 'https://1to19.com').replace(/\/+$/, '');

export function shareOrigin() {
    if (Capacitor.isNativePlatform()) return WEB_URL;
    return window.location.origin;
}

export function joinSocietyUrl(inviteCode) {
    return `${shareOrigin()}/join?code=${encodeURIComponent(inviteCode)}`;
}

export function teeSheetUrl(tournamentId) {
    return `${shareOrigin()}/tournaments/${tournamentId}/teesheet`;
}
